var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureCouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.3 15.5",
    enableBackground: "new 0 0 31.3 15.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    transform: "translate(219.004 -990.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-187.8,996c-0.1-0.1-0.2-0.2-0.4-0.2h-1.6c-0.2,0-0.3,0-0.5,0.1v-2.2 c0-1.7-1.4-3.1-3.1-3.1h-7.9c-1.1,0-2.1,0.6-2.6,1.5c-0.6-0.9-1.6-1.5-2.6-1.5h-7.9c-1.7,0-3.1,1.4-3.1,3.1v2.1h-0.8 c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.1,0.2-0.1,0.4l1.3,9.2c0,0.2,0.2,0.4,0.5,0.4h27.7c0.3,0,0.5-0.2,0.5-0.4l1.3-9.2 C-187.7,996.2-187.7,996.1-187.8,996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-187.8,996c-0.1-0.1-0.2-0.2-0.4-0.2h-1.6c-0.2,0-0.3,0-0.5,0.1v-2.2c0-1.7-1.4-3.1-3.1-3.1 h-7.9c-1.1,0-2.1,0.6-2.6,1.5c-0.6-0.9-1.6-1.5-2.6-1.5h-7.9c-1.7,0-3.1,1.4-3.1,3.1v2.1h-0.8c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.1,0.2-0.1,0.4l1.3,9.2c0,0.2,0.2,0.4,0.5,0.4h27.7c0.3,0,0.5-0.2,0.5-0.4l1.3-9.2C-187.7,996.2-187.7,996.1-187.8,996z  M-203.5,993.6c0-1.2,1-2.1,2.1-2.1h7.9c1.2,0,2.1,1,2.1,2.1v2.9c-0.1,0.2-0.2,0.3-0.3,0.5l-0.4,1.3h-11.6V993.6z M-216.7,993.6 c0-1.2,1-2.1,2.1-2.1h7.9c1.2,0,2.1,1,2.1,2.1v4.8h-10.2l-0.4-1.3c-0.2-0.7-0.8-1.2-1.6-1.3V993.6z M-216.8,1005l-1.2-8.2h1.1 c0.4,0,0.7,0.2,0.8,0.6l0.5,1.6c0,0,0,0.1,0,0.1l1.7,5.9H-216.8z M-212.9,1005l-1.6-5.6h22.2l-1.6,5.6H-212.9z M-189.9,1005h-2.9 l1.7-5.9c0,0,0-0.1,0-0.1l0.5-1.6c0-0.1,0.1-0.2,0.1-0.3l0.1,0c0.2-0.2,0.4-0.3,0.6-0.3h1.1L-189.9,1005z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCouch);
export default __webpack_public_path__ + "static/media/feature-couch.affc1f54d480314cdf7410b7194cb825.svg";
export { ForwardRef as ReactComponent };